import styled from "styled-components";

export const ShiftRemain = styled.p`
  font-size: 1.1rem;
  
  @media (max-width: 992px) {
    font-size: .9rem!important;
  }
`;
